export default __webpack_public_path__ + "static/media/abhishek.c0296da0.jpg";